<input type="text" #search placeholder="Search..." />
